import { useState } from "react";
import { enablePush } from "../lib/push";
import { useSession } from "../lib/session";

const DISMISSED = "learn-push-asked";

export function pushAskDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED) === "1";
  } catch {
    return false;
  }
}

/** Soft ask: say what we will send and why, before the browser's own permission prompt. */
export function PushAskSheet() {
  const { pushAskOpen, closePushAsk, refresh, toast } = useSession();
  const [busy, setBusy] = useState(false);
  if (!pushAskOpen) return null;

  const later = () => {
    try {
      localStorage.setItem(DISMISSED, "1");
    } catch {
      /* private mode: we may ask again next time */
    }
    closePushAsk();
  };
  const turnOn = async () => {
    setBusy(true);
    try {
      await enablePush();
      await refresh();
      toast("Alerts are on for this device.");
      closePushAsk();
    } catch (e) {
      toast((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="scrim" onClick={later} />
      <div className="sheet" role="dialog" aria-modal="true" aria-label="Turn on alerts">
        <div className="grab" />
        <h2 className="h-small">Get an alert when the terms you follow are in the news?</h2>
        <p className="plain small">
          We only notify you about terms you follow, at most a few a day. Your browser will ask for permission
          next. You can turn this off any time under Following.
        </p>
        <div className="acts">
          <button type="button" className="btn ghost" onClick={later}>
            Not now
          </button>
          <button type="button" className="btn" onClick={() => void turnOn()} disabled={busy}>
            {busy ? "Turning on…" : "Turn on"}
          </button>
        </div>
      </div>
    </>
  );
}
